import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// local service
import { getUsers } from 'services';

/* eslint-disable no-unused-vars */
export const getUsersAction = createAsyncThunk('getUsers', async (inp, thunkAPI) => {
  const res = await getUsers();
  return res.data;
});
/* eslint-enable no-unused-vars */

const userSlice = createSlice({
  name: 'users',
  initialState: {
    data: '',
    load: false,
    error: false
  },
  reducers: {},

  extraReducers: {
    [getUsersAction.pending]: state => {
      state.load = true;
    },
    [getUsersAction.fulfilled]: (state, action) => {
      state.load = false;
      state.data = action.payload;
    },
    [getUsersAction.rejected]: (state, action) => {
      state.load = false;
      state.error = action?.error;
    }
  }
});

export default userSlice.reducer;
